module.exports = __webpack_public_path__ + "static/media/messa2_thumb_even.c5c75c27.webp";